import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faLink} from '@netx/core-icons';
import {canSharePdfFromSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionCreatePDFShareLinkIcon = faLink;

/**
 * Create pdf share link from saved cart assets
 * @param params
 * @returns Action
 */
export const cartSavedActionCreatePDFShareLink = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-create-pdf-share-link',
	cb: () =>
		dispatcher.trigger(CART_SAVED_EVENT.CREATE_PDF_SHARE_LINK, savedCart),
	enableTest: () => canSharePdfFromSavedCart(savedCart),
	icon: cartSavedActionCreatePDFShareLinkIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.CREATE_PDF_SHARE_LINK;
	},
	...params,
});

export default cartSavedActionCreatePDFShareLink;
